import { render, staticRenderFns } from "./PriceEditor.vue?vue&type=template&id=1dfde4b6&"
import script from "./PriceEditor.vue?vue&type=script&lang=js&"
export * from "./PriceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports